import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Letras (com acento) e espaço; nada de número, e-mail, apóstrofo ou hífen. */
const NOME_SOCIAL_PERMITIDO = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]*$/;
const TEM_LETRA = /[A-Za-zÀ-ÖØ-öø-ÿ]/;

export const MENSAGEM_NOME_SOCIAL_INVALIDO = 'Nome social aceita apenas letras.';

/** Vazio é permitido; preenchido precisa ter só caracteres permitidos e pelo menos uma letra. */
export function nomeSocialValido(valor: string | null | undefined): boolean {
  const v = (valor ?? '').trim();
  if (!v) return true;
  return NOME_SOCIAL_PERMITIDO.test(v) && TEM_LETRA.test(v);
}

/** Usado nos handlers de input/paste para não deixar digitar o que não é permitido. */
export function filtrarNomeSocial(valor: string): string {
  return (valor ?? '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');
}

export function nomeSocialValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    nomeSocialValido(control.value) ? null : { nomeSocialInvalido: true };
}
